/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CalculateDrawLayerBBox200Response } from '../models';
// @ts-ignore
import type { CopyDrawLayerPayload } from '../models';
// @ts-ignore
import type { CreateDrawLayer200Response } from '../models';
// @ts-ignore
import type { DeleteDrawLayer200Response } from '../models';
// @ts-ignore
import type { DrawLayerCreatePayload } from '../models';
// @ts-ignore
import type { DrawLayerGeometryPatchDTO } from '../models';
// @ts-ignore
import type { DrawLayerUpdateMetadataPayload } from '../models';
// @ts-ignore
import type { GetDrawLayerGeoJson200Response } from '../models';
// @ts-ignore
import type { GetDrawLayersByOperationId200Response } from '../models';
// @ts-ignore
import type { MoveDrawLayerPayload } from '../models';
// @ts-ignore
import type { NamedLatLonCoordinateDTO } from '../models';
/**
 * DrawLayerOperationApi - axios parameter creator
 */
export const DrawLayerOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculate the bounding box based on all features in the draw layer
         * @summary Get the bounding box of a draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {Array<NamedLatLonCoordinateDTO>} [additionalCoordinates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDrawLayerBBox: async (operationId: string, id: string, additionalCoordinates?: Array<NamedLatLonCoordinateDTO>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('calculateDrawLayerBBox', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('calculateDrawLayerBBox', 'id', id)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}/bbox`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (additionalCoordinates) {
                localVarQueryParameter['additionalCoordinates'] = additionalCoordinates;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a copy of this draw layer in another operation
         * @summary Copy draw layer to another operation
         * @param {string} operationId 
         * @param {string} id 
         * @param {CopyDrawLayerPayload} copyDrawLayerPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyOperationDrawLayer: async (operationId: string, id: string, copyDrawLayerPayload: CopyDrawLayerPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('copyOperationDrawLayer', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('copyOperationDrawLayer', 'id', id)
            // verify required parameter 'copyDrawLayerPayload' is not null or undefined
            assertParamExists('copyOperationDrawLayer', 'copyDrawLayerPayload', copyDrawLayerPayload)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}/copy`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyDrawLayerPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new draw layer within the specified operation
         * @summary Create a draw layer in this operation
         * @param {string} operationId 
         * @param {DrawLayerCreatePayload} drawLayerCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrawLayer: async (operationId: string, drawLayerCreatePayload: DrawLayerCreatePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('createDrawLayer', 'operationId', operationId)
            // verify required parameter 'drawLayerCreatePayload' is not null or undefined
            assertParamExists('createDrawLayer', 'drawLayerCreatePayload', drawLayerCreatePayload)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(drawLayerCreatePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a specific draw layer in this operation. This is a soft-delete.
         * @summary Delete a draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrawLayer: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('deleteDrawLayer', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDrawLayer', 'id', id)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific draw layer within the operation
         * @summary Get a draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayer: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getDrawLayer', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDrawLayer', 'id', id)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the geometry of a draw layer in this operation
         * @summary Get a draw layer\'s geometry
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerGeoJson: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getDrawLayerGeoJson', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDrawLayerGeoJson', 'id', id)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}/geojson`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all draw layers within the specified operation
         * @summary List all draw layers in this operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayersByOperationId: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getDrawLayersByOperationId', 'operationId', operationId)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a draw layer from this operation to another operation
         * @summary Move a draw layer to a different operation
         * @param {string} operationId 
         * @param {string} id 
         * @param {MoveDrawLayerPayload} moveDrawLayerPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveOperationDrawLayer: async (operationId: string, id: string, moveDrawLayerPayload: MoveDrawLayerPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('moveOperationDrawLayer', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveOperationDrawLayer', 'id', id)
            // verify required parameter 'moveDrawLayerPayload' is not null or undefined
            assertParamExists('moveOperationDrawLayer', 'moveDrawLayerPayload', moveDrawLayerPayload)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}/move`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveDrawLayerPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a draw layer\'s geojson features/geometry
         * @summary Update a draw layer\'s features/geometry
         * @param {string} operationId 
         * @param {string} id 
         * @param {DrawLayerGeometryPatchDTO} drawLayerGeometryPatchDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDrawLayerGeometry: async (operationId: string, id: string, drawLayerGeometryPatchDTO: DrawLayerGeometryPatchDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('patchDrawLayerGeometry', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchDrawLayerGeometry', 'id', id)
            // verify required parameter 'drawLayerGeometryPatchDTO' is not null or undefined
            assertParamExists('patchDrawLayerGeometry', 'drawLayerGeometryPatchDTO', drawLayerGeometryPatchDTO)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}/features`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(drawLayerGeometryPatchDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish a draft draw layer, making it visible to all operation members
         * @summary Publish a draft draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDrawLayer: async (operationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('publishDrawLayer', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('publishDrawLayer', 'id', id)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}/publish`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a draw layer\'s metadata within this operation
         * @summary Update a draw layer\'s metadata
         * @param {string} operationId 
         * @param {string} id 
         * @param {DrawLayerUpdateMetadataPayload} drawLayerUpdateMetadataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrawLayerMetaData: async (operationId: string, id: string, drawLayerUpdateMetadataPayload: DrawLayerUpdateMetadataPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('updateDrawLayerMetaData', 'operationId', operationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDrawLayerMetaData', 'id', id)
            // verify required parameter 'drawLayerUpdateMetadataPayload' is not null or undefined
            assertParamExists('updateDrawLayerMetaData', 'drawLayerUpdateMetadataPayload', drawLayerUpdateMetadataPayload)
            const localVarPath = `/api/nora/draw-layer/operation/{operationId}/{id}`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(drawLayerUpdateMetadataPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DrawLayerOperationApi - functional programming interface
 */
export const DrawLayerOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DrawLayerOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * Calculate the bounding box based on all features in the draw layer
         * @summary Get the bounding box of a draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {Array<NamedLatLonCoordinateDTO>} [additionalCoordinates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateDrawLayerBBox(operationId: string, id: string, additionalCoordinates?: Array<NamedLatLonCoordinateDTO>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateDrawLayerBBox200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateDrawLayerBBox(operationId, id, additionalCoordinates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.calculateDrawLayerBBox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a copy of this draw layer in another operation
         * @summary Copy draw layer to another operation
         * @param {string} operationId 
         * @param {string} id 
         * @param {CopyDrawLayerPayload} copyDrawLayerPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyOperationDrawLayer(operationId: string, id: string, copyDrawLayerPayload: CopyDrawLayerPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyOperationDrawLayer(operationId, id, copyDrawLayerPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.copyOperationDrawLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new draw layer within the specified operation
         * @summary Create a draw layer in this operation
         * @param {string} operationId 
         * @param {DrawLayerCreatePayload} drawLayerCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDrawLayer(operationId: string, drawLayerCreatePayload: DrawLayerCreatePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDrawLayer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDrawLayer(operationId, drawLayerCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.createDrawLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a specific draw layer in this operation. This is a soft-delete.
         * @summary Delete a draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDrawLayer(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteDrawLayer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDrawLayer(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.deleteDrawLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific draw layer within the operation
         * @summary Get a draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawLayer(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDrawLayer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawLayer(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.getDrawLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the geometry of a draw layer in this operation
         * @summary Get a draw layer\'s geometry
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawLayerGeoJson(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDrawLayerGeoJson200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawLayerGeoJson(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.getDrawLayerGeoJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all draw layers within the specified operation
         * @summary List all draw layers in this operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawLayersByOperationId(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDrawLayersByOperationId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawLayersByOperationId(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.getDrawLayersByOperationId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move a draw layer from this operation to another operation
         * @summary Move a draw layer to a different operation
         * @param {string} operationId 
         * @param {string} id 
         * @param {MoveDrawLayerPayload} moveDrawLayerPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveOperationDrawLayer(operationId: string, id: string, moveDrawLayerPayload: MoveDrawLayerPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveOperationDrawLayer(operationId, id, moveDrawLayerPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.moveOperationDrawLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a draw layer\'s geojson features/geometry
         * @summary Update a draw layer\'s features/geometry
         * @param {string} operationId 
         * @param {string} id 
         * @param {DrawLayerGeometryPatchDTO} drawLayerGeometryPatchDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDrawLayerGeometry(operationId: string, id: string, drawLayerGeometryPatchDTO: DrawLayerGeometryPatchDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDrawLayerGeometry(operationId, id, drawLayerGeometryPatchDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.patchDrawLayerGeometry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish a draft draw layer, making it visible to all operation members
         * @summary Publish a draft draw layer
         * @param {string} operationId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishDrawLayer(operationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDrawLayer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishDrawLayer(operationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.publishDrawLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a draw layer\'s metadata within this operation
         * @summary Update a draw layer\'s metadata
         * @param {string} operationId 
         * @param {string} id 
         * @param {DrawLayerUpdateMetadataPayload} drawLayerUpdateMetadataPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDrawLayerMetaData(operationId: string, id: string, drawLayerUpdateMetadataPayload: DrawLayerUpdateMetadataPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDrawLayer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDrawLayerMetaData(operationId, id, drawLayerUpdateMetadataPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerOperationApi.updateDrawLayerMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DrawLayerOperationApi - factory interface
 */
export const DrawLayerOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DrawLayerOperationApiFp(configuration)
    return {
        /**
         * Calculate the bounding box based on all features in the draw layer
         * @summary Get the bounding box of a draw layer
         * @param {DrawLayerOperationApiCalculateDrawLayerBBoxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDrawLayerBBox(requestParameters: DrawLayerOperationApiCalculateDrawLayerBBoxRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalculateDrawLayerBBox200Response> {
            return localVarFp.calculateDrawLayerBBox(requestParameters.operationId, requestParameters.id, requestParameters.additionalCoordinates, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a copy of this draw layer in another operation
         * @summary Copy draw layer to another operation
         * @param {DrawLayerOperationApiCopyOperationDrawLayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyOperationDrawLayer(requestParameters: DrawLayerOperationApiCopyOperationDrawLayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.copyOperationDrawLayer(requestParameters.operationId, requestParameters.id, requestParameters.copyDrawLayerPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new draw layer within the specified operation
         * @summary Create a draw layer in this operation
         * @param {DrawLayerOperationApiCreateDrawLayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDrawLayer(requestParameters: DrawLayerOperationApiCreateDrawLayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDrawLayer200Response> {
            return localVarFp.createDrawLayer(requestParameters.operationId, requestParameters.drawLayerCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a specific draw layer in this operation. This is a soft-delete.
         * @summary Delete a draw layer
         * @param {DrawLayerOperationApiDeleteDrawLayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrawLayer(requestParameters: DrawLayerOperationApiDeleteDrawLayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteDrawLayer200Response> {
            return localVarFp.deleteDrawLayer(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific draw layer within the operation
         * @summary Get a draw layer
         * @param {DrawLayerOperationApiGetDrawLayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayer(requestParameters: DrawLayerOperationApiGetDrawLayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDrawLayer200Response> {
            return localVarFp.getDrawLayer(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the geometry of a draw layer in this operation
         * @summary Get a draw layer\'s geometry
         * @param {DrawLayerOperationApiGetDrawLayerGeoJsonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerGeoJson(requestParameters: DrawLayerOperationApiGetDrawLayerGeoJsonRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDrawLayerGeoJson200Response> {
            return localVarFp.getDrawLayerGeoJson(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List all draw layers within the specified operation
         * @summary List all draw layers in this operation
         * @param {DrawLayerOperationApiGetDrawLayersByOperationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayersByOperationId(requestParameters: DrawLayerOperationApiGetDrawLayersByOperationIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDrawLayersByOperationId200Response> {
            return localVarFp.getDrawLayersByOperationId(requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a draw layer from this operation to another operation
         * @summary Move a draw layer to a different operation
         * @param {DrawLayerOperationApiMoveOperationDrawLayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveOperationDrawLayer(requestParameters: DrawLayerOperationApiMoveOperationDrawLayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.moveOperationDrawLayer(requestParameters.operationId, requestParameters.id, requestParameters.moveDrawLayerPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a draw layer\'s geojson features/geometry
         * @summary Update a draw layer\'s features/geometry
         * @param {DrawLayerOperationApiPatchDrawLayerGeometryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDrawLayerGeometry(requestParameters: DrawLayerOperationApiPatchDrawLayerGeometryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.patchDrawLayerGeometry(requestParameters.operationId, requestParameters.id, requestParameters.drawLayerGeometryPatchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish a draft draw layer, making it visible to all operation members
         * @summary Publish a draft draw layer
         * @param {DrawLayerOperationApiPublishDrawLayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDrawLayer(requestParameters: DrawLayerOperationApiPublishDrawLayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDrawLayer200Response> {
            return localVarFp.publishDrawLayer(requestParameters.operationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a draw layer\'s metadata within this operation
         * @summary Update a draw layer\'s metadata
         * @param {DrawLayerOperationApiUpdateDrawLayerMetaDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrawLayerMetaData(requestParameters: DrawLayerOperationApiUpdateDrawLayerMetaDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDrawLayer200Response> {
            return localVarFp.updateDrawLayerMetaData(requestParameters.operationId, requestParameters.id, requestParameters.drawLayerUpdateMetadataPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculateDrawLayerBBox operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiCalculateDrawLayerBBoxRequest {
    readonly operationId: string

    readonly id: string

    readonly additionalCoordinates?: Array<NamedLatLonCoordinateDTO>
}

/**
 * Request parameters for copyOperationDrawLayer operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiCopyOperationDrawLayerRequest {
    readonly operationId: string

    readonly id: string

    readonly copyDrawLayerPayload: CopyDrawLayerPayload
}

/**
 * Request parameters for createDrawLayer operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiCreateDrawLayerRequest {
    readonly operationId: string

    readonly drawLayerCreatePayload: DrawLayerCreatePayload
}

/**
 * Request parameters for deleteDrawLayer operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiDeleteDrawLayerRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for getDrawLayer operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiGetDrawLayerRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for getDrawLayerGeoJson operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiGetDrawLayerGeoJsonRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for getDrawLayersByOperationId operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiGetDrawLayersByOperationIdRequest {
    readonly operationId: string
}

/**
 * Request parameters for moveOperationDrawLayer operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiMoveOperationDrawLayerRequest {
    readonly operationId: string

    readonly id: string

    readonly moveDrawLayerPayload: MoveDrawLayerPayload
}

/**
 * Request parameters for patchDrawLayerGeometry operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiPatchDrawLayerGeometryRequest {
    readonly operationId: string

    readonly id: string

    readonly drawLayerGeometryPatchDTO: DrawLayerGeometryPatchDTO
}

/**
 * Request parameters for publishDrawLayer operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiPublishDrawLayerRequest {
    readonly operationId: string

    readonly id: string
}

/**
 * Request parameters for updateDrawLayerMetaData operation in DrawLayerOperationApi.
 */
export interface DrawLayerOperationApiUpdateDrawLayerMetaDataRequest {
    readonly operationId: string

    readonly id: string

    readonly drawLayerUpdateMetadataPayload: DrawLayerUpdateMetadataPayload
}

/**
 * DrawLayerOperationApi - object-oriented interface
 */
export class DrawLayerOperationApi extends BaseAPI {
    /**
     * Calculate the bounding box based on all features in the draw layer
     * @summary Get the bounding box of a draw layer
     * @param {DrawLayerOperationApiCalculateDrawLayerBBoxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculateDrawLayerBBox(requestParameters: DrawLayerOperationApiCalculateDrawLayerBBoxRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).calculateDrawLayerBBox(requestParameters.operationId, requestParameters.id, requestParameters.additionalCoordinates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a copy of this draw layer in another operation
     * @summary Copy draw layer to another operation
     * @param {DrawLayerOperationApiCopyOperationDrawLayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyOperationDrawLayer(requestParameters: DrawLayerOperationApiCopyOperationDrawLayerRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).copyOperationDrawLayer(requestParameters.operationId, requestParameters.id, requestParameters.copyDrawLayerPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new draw layer within the specified operation
     * @summary Create a draw layer in this operation
     * @param {DrawLayerOperationApiCreateDrawLayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createDrawLayer(requestParameters: DrawLayerOperationApiCreateDrawLayerRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).createDrawLayer(requestParameters.operationId, requestParameters.drawLayerCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a specific draw layer in this operation. This is a soft-delete.
     * @summary Delete a draw layer
     * @param {DrawLayerOperationApiDeleteDrawLayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteDrawLayer(requestParameters: DrawLayerOperationApiDeleteDrawLayerRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).deleteDrawLayer(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific draw layer within the operation
     * @summary Get a draw layer
     * @param {DrawLayerOperationApiGetDrawLayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrawLayer(requestParameters: DrawLayerOperationApiGetDrawLayerRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).getDrawLayer(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the geometry of a draw layer in this operation
     * @summary Get a draw layer\'s geometry
     * @param {DrawLayerOperationApiGetDrawLayerGeoJsonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrawLayerGeoJson(requestParameters: DrawLayerOperationApiGetDrawLayerGeoJsonRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).getDrawLayerGeoJson(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all draw layers within the specified operation
     * @summary List all draw layers in this operation
     * @param {DrawLayerOperationApiGetDrawLayersByOperationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrawLayersByOperationId(requestParameters: DrawLayerOperationApiGetDrawLayersByOperationIdRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).getDrawLayersByOperationId(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a draw layer from this operation to another operation
     * @summary Move a draw layer to a different operation
     * @param {DrawLayerOperationApiMoveOperationDrawLayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moveOperationDrawLayer(requestParameters: DrawLayerOperationApiMoveOperationDrawLayerRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).moveOperationDrawLayer(requestParameters.operationId, requestParameters.id, requestParameters.moveDrawLayerPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a draw layer\'s geojson features/geometry
     * @summary Update a draw layer\'s features/geometry
     * @param {DrawLayerOperationApiPatchDrawLayerGeometryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchDrawLayerGeometry(requestParameters: DrawLayerOperationApiPatchDrawLayerGeometryRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).patchDrawLayerGeometry(requestParameters.operationId, requestParameters.id, requestParameters.drawLayerGeometryPatchDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish a draft draw layer, making it visible to all operation members
     * @summary Publish a draft draw layer
     * @param {DrawLayerOperationApiPublishDrawLayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public publishDrawLayer(requestParameters: DrawLayerOperationApiPublishDrawLayerRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).publishDrawLayer(requestParameters.operationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a draw layer\'s metadata within this operation
     * @summary Update a draw layer\'s metadata
     * @param {DrawLayerOperationApiUpdateDrawLayerMetaDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateDrawLayerMetaData(requestParameters: DrawLayerOperationApiUpdateDrawLayerMetaDataRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerOperationApiFp(this.configuration).updateDrawLayerMetaData(requestParameters.operationId, requestParameters.id, requestParameters.drawLayerUpdateMetadataPayload, options).then((request) => request(this.axios, this.basePath));
    }
}

